import React, { Component, Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { Link, Redirect } from 'react-router-dom';
import ProgressBar from 'progressbar.js';
import Button from '../../artzu-ui/src/Button';
import Divider from '../../artzu-ui/src/Divider';

import ResultText from './ResultText';
import FailedButtonGroup from './FailedButtonGroup';

class Result extends Component {
  componentDidMount() {
    const scoreDecimal = this.props.score / 20.0;
    const from = { color: '#FF0000' };
    const to = this.toColor(scoreDecimal);
    const progress = new ProgressBar.Circle('#progressbar', {
      step: this.stepCallback,
      strokeWidth: 6,
      trailWidth: 6,
      duration: 1400,
      easing: 'easeInOut',
      text: { className: 'progressbar__label' }
    });

    // progress.path.style.strokeLinecap = 'round';
    setTimeout(() => progress.animate(scoreDecimal, { from, to }), 1000);

    progress.text.style.fontFamily = 'Helvetica, sans-serif';
    progress.text.style.fontSize = '2em';
  }

  stepCallback = (state, circle) => {
    const percent = Math.round(circle.value() * 100);
    // if (circle.text) circle.text.style.color = state.color;
    circle.setText(`${percent}%`);
    circle.path.setAttribute('stroke', state.color);
  };

  toColor = scoreDecimal => {
    let to;
    if (scoreDecimal < 0.75) {
      to = '#FF0000';
    } else if (scoreDecimal >= 0.75) {
      to = '#128DFF';
    }
    return { color: to };
  };

  resultText = () => {
    const { score, retakeExam } = this.props;
    if (score < 15) {
      // if (score < 16) {
      return (
        <ResultText status="failed" heading="Please Try Again">
          <p>
            Sorry, you did not answer enough questions correctly to pass
            the quiz. <br />You can review the content and try again.
          </p>
          {/* <FailedButtonGroup retakeExam={retakeExam} /> */}
          <div className="new-exam__body__results__failed__buttons">
            {/* <Link to="/course">
              <Button
                color="#414141"
                label="Course"
                // size="xl"
              />
            </Link>
            <Button
              color="#128DFF"
              label="Try Again"
              // size="xl"
              onClick={retakeExam}
            /> */}
          </div>
        </ResultText>
      );
    } else {
      // } else if (score >= 16) {
      return (
        <ResultText status="passed" heading="Congratulations!">
          <p>
            You have successfully completed the online course. The next
            step is to complete the in-person demonstration.
          </p>
          {/* <hr
            style={{ 'border-top': '1px solid #DEDEDE', width: '100%' }}
          /> */}
          {/* <Divider width="100%" /> */}
          {/* <Link to="book">
            <Button
              color="#128DFF"
              label="Book Demo"
              size="xl"
              id="new-exam__result__pass__button"
            />
          </Link> */}
        </ResultText>
      );
    }
  };

  renderBook = () => {
    return /examhtml/.test(window.location.href) ? 
      <a href="/book">
        <Button
          padding="0"
          primary
          label="Book Demo"
          fullWidth
          size="xl"
          className=""
        />
      </a> : 
      <Link to="book">
        <Button
          padding="0"
          primary
          label="Book Demo"
          fullWidth
          size="xl"
          className=""
        />
      </Link>
  };

  renderDashboard = () => {
    return (
      <Link to="dashboard">
        <Button padding="0" primary label="Dashboard" size="xl" className="" />
      </Link>
    );
  };

  renderReview = () => {
    return (
      <Link to={/examhtml/.test(window.location.href) ? "coursehtml" : "course"}>
        <Button padding="0" primary label="Review Course" size="xl" className="" />
      </Link>
    );
  };

  render() {
    const { score, retakeExam } = this.props;
    return (
      <Fragment>
        <div className="new-exam__body__results">
          <div className="progressbar__container">
            <div id="progressbar" />
          </div>
          {this.resultText()}
          <br />
          <br />
          <br />
        </div>
        {/* <hr
          style={{
            'border-top': '1px solid #DEDEDE',
            width: '100%',
            margin: '10px 0'
          }}
        /> */}
        <div className="new-exam__body__results__footerButtons--mobile">
          {score >= 16 ? this.renderBook() : this.renderReview()}
        </div>

        <div className="new-exam__body__results__footerButtons--desktop">
          {score >= 16 ? this.renderBook() : this.renderReview()}
        </div>
      </Fragment>
    );
  }
}

export default Result;



// WEBPACK FOOTER //
// ./src/components/NewExam/Result.js